import type { PriceLibraryRow } from "../../components/settings/settings-types.ts";

export type PriceLibraryFilter = {
  moduleCode: string;
  query: string;
};

export function filterPriceLibraryItems(items: PriceLibraryRow[], filter: PriceLibraryFilter): PriceLibraryRow[] {
  const moduleCode = filter.moduleCode.trim();
  const query = filter.query.trim().toLowerCase();

  return items.filter((item) => {
    if (moduleCode && moduleCode !== "all" && item.moduleCode !== moduleCode) {
      return false;
    }

    if (!query) {
      return true;
    }

    return [item.nameEn, item.nameZh, item.descriptionEn, item.descriptionZh, item.defaultUnit]
      .filter((value): value is string => Boolean(value))
      .some((value) => value.toLowerCase().includes(query));
  });
}

export function movePriceItemInModuleOrder(
  items: Pick<PriceLibraryRow, "id" | "moduleCode" | "nameEn" | "sortOrder">[],
  itemId: string,
  direction: "up" | "down",
): Array<{ id: string; sortOrder: number }> {
  const selected = items.find((item) => item.id === itemId);

  if (!selected) {
    return [];
  }

  const ordered = items
    .filter((item) => item.moduleCode === selected.moduleCode)
    .sort((left, right) => left.sortOrder - right.sortOrder || left.nameEn.localeCompare(right.nameEn) || left.id.localeCompare(right.id));
  const index = ordered.findIndex((item) => item.id === itemId);
  const targetIndex = direction === "up" ? index - 1 : index + 1;
  const target = ordered[targetIndex];
  const source = ordered[index];

  if (!target || !source) {
    return [];
  }

  [ordered[index], ordered[targetIndex]] = [target, source];

  return ordered
    .map((item, itemIndex) => ({ id: item.id, sortOrder: (itemIndex + 1) * 10 }))
    .filter((patch) => items.find((item) => item.id === patch.id)?.sortOrder !== patch.sortOrder);
}
